// Motion design tokens — single source of truth for all animation timings,
// easings, and distances across the embed shell. Surfaces import these
// instead of hardcoding magic numbers so we can tune the whole feel from
// one place if a customer requests a calmer or snappier curve.

export const DUR = {
  fast: 150,
  base: 250,
  // Page transitions intentionally match `base` so paged surveys feel as
  // smooth as conversational ones (which slide a single element). Pulling
  // them apart introduces a perceptible rhythm difference between the two
  // display modes — keep them aligned unless the design explicitly diverges.
  page: 250,
  modal: 350,
  progress: 500,
  success: 600,
} as const;

export const EASE = {
  // Material-style — used for most interactive elements.
  standard: 'cubic-bezier(0.2, 0, 0.2, 1)',
  // Slight overshoot — Typeform-y feel for entering modals and pages.
  overshoot: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  // Decelerate-only — gentler than overshoot, good for exits.
  out: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  // Linear for progress bars and indeterminate loops.
  linear: 'linear',
} as const;

export const DIST = {
  page: 16,
  field: 8,
  drawer: 24,
} as const;

export const STAGGER_MS = 50;
// Cap stagger so a 20-question page doesn't take 1+ seconds to fully settle in.
export const STAGGER_CAP = 5;
